// The quiz's GIF collection. Figma references a GIF by its name (the key here),
// and a screen config picks one with `gif: '<name>'`. The files live in
// public/img/gifs/<name>.webp: animated WebP converted from the source GIFs,
// which keeps transparency and looping at a fraction of the size.
//
// To add one, run `yarn gif:add <file.gif> <name>` and paste the entry it
// prints here. See "GIFs" in the README for naming, size limits and usage.

type GifMeta = {
  width: number
  height: number
  alt: string
}

export const GIFS = {
  'ziggie-idle': { width: 560, height: 680, alt: 'Ziggie' },
  'ziggie-praise': { width: 560, height: 680, alt: 'Ziggie cheering' },
  'ziggie-idea': { width: 560, height: 680, alt: 'Ziggie having an idea' },
  'ziggie-head-scratch': { width: 560, height: 680, alt: 'Ziggie scratching their head' },
  'ziggie-wave': { width: 560, height: 680, alt: 'Ziggie waving' },
} satisfies Record<string, GifMeta>

export type GifName = keyof typeof GIFS

export const gifSrc = (name: GifName): string => `/img/gifs/${name}.webp`

export const gifAspectRatio = (name: GifName): string => `${GIFS[name].width} / ${GIFS[name].height}`

type TopImage = { topImage?: string; topImageAlt?: string; topImageAspectRatio?: string }

// A screen's top image, with a GIF from the collection standing in for it when
// one is given. Explicit alt text or aspect ratio still win.
export const resolveTopImage = (gif: GifName | undefined, image: TopImage): TopImage =>
  gif
    ? {
        topImage: gifSrc(gif),
        topImageAlt: image.topImageAlt ?? GIFS[gif].alt,
        topImageAspectRatio: image.topImageAspectRatio ?? gifAspectRatio(gif),
      }
    : image
